<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import WorkshopCard from './WorkshopCard.vue'

defineProps<{
    workshops: Workshop[]
}>()
</script>

<template>
    <section class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <WorkshopCard v-for="workshop in workshops" :key="workshop.id" :workshop="workshop" />
    </section>
</template>
